import { render } from "./QuestionTwoView.vue?vue&type=template&id=36092e95&scoped=true&ts=true"
import script from "./QuestionTwoView.vue?vue&type=script&lang=ts"
export * from "./QuestionTwoView.vue?vue&type=script&lang=ts"

import "./QuestionTwoView.vue?vue&type=style&index=0&id=36092e95&lang=scss&scoped=true"
import "./QuestionTwoView.vue?vue&type=style&index=1&id=36092e95&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36092e95"]])

export default __exports__